export default [
	'OPEN',
	'OVERDUE',
	'CLOSED'
];
